export enum WageAndTravelType {    
    ReimburseWagesOnly  = 1,
    ReimburseTravelOnly = 2,
    ReimburseBoth       = 3
}